@charset "UTF-8";

/* src/app/warehousing/partials/warehousing-charts/warehousing-charts.component.scss */
.chart-holder {
  height: 20rem;
  width: 100%;
}
.chart-holder--tall {
  height: 24rem;
}
::ng-deep .gridline-path {
  stroke: #ecebe9;
  stroke-width: 1;
  stroke-dasharray: none !important;
}
::ng-deep .axis path,
::ng-deep .axis line {
  stroke: #d8d6d3;
  shape-rendering: crispEdges;
}
::ng-deep .axis text,
::ng-deep .legend-label-text {
  fill: #55534f;
  color: #55534f;
  font-size: 0.75rem;
}
::ng-deep .axis-label {
  fill: #7a7873;
  font-size: 0.75rem;
}
::ng-deep .bar {
  stroke: #ffffff;
  stroke-width: 2;
}
::ng-deep .pie-label {
  fill: #55534f;
  font-size: 0.75rem;
}
::ng-deep .pie-arc {
  stroke: #ffffff;
  stroke-width: 2;
}
.chart-table {
  font-size: 0.8rem;
}
.chart-table th,
.chart-table td {
  padding: 0.3rem 0.5rem;
}
.chart-table td.numeric {
  font-variant-numeric: tabular-nums;
  text-align: right;
}
.series-chip {
  display: inline-block;
  width: 0.7rem;
  height: 0.7rem;
  border-radius: 0.15rem;
  margin-right: 0.4rem;
  vertical-align: baseline;
}
/*# sourceMappingURL=warehousing-charts.component.css.map */
